document.addEventListener('DOMContentLoaded', function () {
  const tabs = Array.from(document.querySelectorAll('.faq__wrapper .faq__tabs-item'));
  const details = Array.from(document.querySelectorAll('.faq__wrapper details'));
  const searchInput = document.getElementById('faq-search-input');

  // ---------- Highlighting utilities ----------
  function escapeRegExp(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  // Remove existing <mark> without disturbing other HTML
  function clearHighlights(root) {
    if (!root) return;
    const marks = root.querySelectorAll('mark');
    marks.forEach(mark => {
      const parent = mark.parentNode;
      // Replace the <mark> with a text node of its content
      parent.replaceChild(document.createTextNode(mark.textContent), mark);
      parent.normalize(); // merge adjacent text nodes
    });
  }

  // Highlight all occurrences of term inside text nodes of root (case-insensitive)
  function highlightElement(root, term) {
    if (!root || !term) return;

    const regex = new RegExp(escapeRegExp(term), 'gi');
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        // Skip text nodes inside <script>, <style>, or already-marked areas
        const p = node.parentNode;
        if (!node.nodeValue || !node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
        if (!p) return NodeFilter.FILTER_REJECT;
        const tag = p.nodeName.toLowerCase();
        if (tag === 'script' || tag === 'style') return NodeFilter.FILTER_REJECT;
        if (tag === 'mark') return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    const toProcess = [];
    while (walker.nextNode()) {
      // collect first to avoid live DOM mutation issues
      if (regex.test(walker.currentNode.nodeValue)) {
        toProcess.push(walker.currentNode);
      }
      regex.lastIndex = 0; // reset for next node
    }

    toProcess.forEach(textNode => {
      const frag = document.createDocumentFragment();
      let text = textNode.nodeValue;
      let lastIndex = 0;
      let match;

      while ((match = regex.exec(text)) !== null) {
        const start = match.index;
        const end = start + match[0].length;

        if (start > lastIndex) {
          frag.appendChild(document.createTextNode(text.slice(lastIndex, start)));
        }

        const mark = document.createElement('mark');
        mark.textContent = text.slice(start, end);
        frag.appendChild(mark);

        lastIndex = end;
      }

      if (lastIndex < text.length) {
        frag.appendChild(document.createTextNode(text.slice(lastIndex)));
      }

      textNode.parentNode.replaceChild(frag, textNode);
    });
  }

  function applyHighlights(summary, content, term) {
    // Clear previous highlights first
    clearHighlights(summary);
    clearHighlights(content);
    if (!term) return;
    highlightElement(summary, term);
    highlightElement(content, term);
  }
  // ---------- End highlighting utilities ----------

  // Utility to get current active tab slug (or null for all)
  function getActiveTab() {
    const active = tabs.find(t => t.classList.contains('active'));
    return active ? active.getAttribute('data-tab') : null;
  }

  // Show/hide details based on active tab and current search term
  function refreshVisibility() {
    const activeTab = getActiveTab();
    const searchTerm = searchInput ? searchInput.value.trim().toLowerCase() : '';

    details.forEach(d => {
      const matchesTab = !activeTab || d.classList.contains(activeTab);
      const summary = d.querySelector('summary');
      const content = d.querySelector('.faq__accordion__item-wrap');

      // Use combined text for match decision
      const titleText = summary ? summary.textContent || '' : '';
      const bodyText = content ? content.textContent || '' : '';
      const combined = (titleText + ' ' + bodyText).toLowerCase();
      const matchesSearch = searchTerm === '' || combined.includes(searchTerm);

      if (matchesTab && matchesSearch) {
        d.style.display = '';
        // Apply highlights when visible
        applyHighlights(summary, content, searchTerm);
      } else {
        // Hide and clear highlights to keep markup clean
        d.style.display = 'none';
        clearHighlights(summary);
        clearHighlights(content);
      }
    });

    // Optional: update feedback if you have the search feedback element
    if (searchInput) {
      const feedback = document.getElementById('faq-search-feedback');
      if (feedback) {
        const visibleCount = details.filter(d => d.style.display !== 'none').length;
        if (searchTerm === '') {
          feedback.textContent = '';
        } else if (visibleCount === 0) {
          feedback.textContent = 'No results found.';
        } else {
          feedback.textContent = `${visibleCount} result${visibleCount === 1 ? '' : 's'} found.`;
        }
      }
    }
  }

  // Tab click/focus handling
  tabs.forEach(tab => {
    const activate = () => {
      tabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
      refreshVisibility();
    };

    tab.addEventListener('click', activate);
    tab.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        activate();
      }
    });
  });

  // If no tab is marked active on load, optionally activate the first
  if (!tabs.some(t => t.classList.contains('active')) && tabs.length) {
    tabs[0].classList.add('active');
  }

  // Search input integration (if present)
  if (searchInput) {
    let debounceTimer = null;
    searchInput.addEventListener('input', () => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(refreshVisibility, 150);
    });

    // Optional: clear search with Escape
    searchInput.addEventListener('keydown', e => {
      if (e.key === 'Escape') {
        searchInput.value = '';
        refreshVisibility();
        searchInput.blur();
      }
    });
  }

  // Initial render pass
  refreshVisibility();
});
